/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type llm_chat_StreamResponse = {
    chunk?: string;
    command?: string;
    error?: string;
    event?: llm_chat_StreamResponse.event;
    message?: string;
    tool?: string;
};

export namespace llm_chat_StreamResponse {

    export enum event {
        ERROR = 'error',
        TOOL_CALL_RESULTS = 'tool_call_results',
        CHUNK = 'chunk',
        TOOL_CALL_START = 'tool_call_start',
        TOOL_CALL_END = 'tool_call_end',
        TOOL_CALL_PROGRESS = 'tool_call_progress',
        COMMAND = 'command',
    }


}

